'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _legacyI18nInit = require('../legacyI18nInit');

var _hsIntl = require('../hs-intl');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = function (options) {
  var _create = (0, _hsIntl.create)(),
      _setLocale = _create.setLocale,
      rest = _objectWithoutProperties(_create, ['setLocale']);

  var I18nProvider = _extends({
    setLocale: function setLocale(_ref) {
      var locale = _ref.locale,
          langEnabled = _ref.langEnabled,
          timezone = _ref.timezone;

      (0, _legacyI18nInit.setManualOverwrites)();
      (0, _legacyI18nInit.setupTimezone)(timezone);

      var validLocale = (0, _legacyI18nInit.getValidLocale)(locale);
      I18n.langEnabled = !!I18n.manualLocale || langEnabled;
      I18n.locale = validLocale;

      var loaderLocales = [validLocale];

      var shouldLoadFallback = !(options && options.excludeFallback);
      if (shouldLoadFallback && validLocale !== _legacyI18nInit.defaultLanguage) {
        loaderLocales.push(_legacyI18nInit.defaultLanguage);
      }

      I18n.fired.ready = true;
      I18n.Info.resolve({
        locale: I18n.locale,
        langEnabled: I18n.langEnabled,
        timezone: I18n.timezone
      });

      if (I18n.moment) {
        var validMomentLocale = _legacyI18nInit.momentMappings[I18n.locale] || _legacyI18nInit.momentMappings[I18n.locale.split('-')[0]] || _legacyI18nInit.defaultLanguage;
        I18n.moment.locale(validMomentLocale);
      }

      return _setLocale(loaderLocales);
    }
  }, rest);

  return I18nProvider;
};

module.exports = exports['default'];